import { cn } from "@/shared/lib/utils"

/**
 * Default chrome for fixed bottom `vaul`/`Drawer.Content` and `DrawerContent`.
 * Outer top margin clears Telegram Mini App controls (aligned with `--app-safe-top` from `telegram.ts`).
 * Bottom/sides: gesture bar + content safe cutouts via padding on the sheet edge (scroll stays inside callers’ column).
 */
export const VAUL_BOTTOM_SHEET_SAFE_OUTER_CLASSNAME = cn(
  "mt-[var(--app-safe-top)] max-h-[calc(100dvh-var(--app-safe-top))] min-h-0",
  "pb-[var(--app-safe-bottom)]",
  "pl-[max(env(safe-area-inset-left,0px),var(--tg-content-safe-area-inset-left,0px))]",
  "pr-[max(env(safe-area-inset-right,0px),var(--tg-content-safe-area-inset-right,0px))]"
)
